import DataFileList from "@/features/files/list";

const DataFiles = () => {
  return <DataFileList />;
};

export default DataFiles;
